import { IDemographicsReportParams } from '~/services/api/types';

const toNumberArray = (ids?: Array<string | number>): number[] | null =>
  ids?.length ? ids.map(Number) : null;

const toDemographicsFilterBody = ({
  teamIds,
  columns,
  'ageRange.from': ageFrom,
  'ageRange.to': ageTo,
  zipCode,
  diagnosisIds,
  triggerIds,
  medicationIds,
  onlyActive,
  rowsCount,
  sorting,
  sortDirection,
  filterLogic,
}: IDemographicsReportParams) => ({
  teamIds: teamIds?.map(Number),
  rowsCount,
  columns,
  ageRange: { from: Number(ageFrom), to: Number(ageTo) },
  zipCode,
  diagnosisIds: toNumberArray(diagnosisIds),
  triggerIds: toNumberArray(triggerIds),
  medicationIds: toNumberArray(medicationIds),
  onlyActive,
  sorting,
  sortDirection,
  filterLogic,
});

export default toDemographicsFilterBody;
